<span>{{ dateLabel }} {{ dateRange.startDate | date : 'MM/dd/yyyy' }}</span>
<span>&nbsp;&ndash;&nbsp;</span>
<span>{{ dateRange.endDate | date : 'MM/dd/yyyy' }}</span>
<span>&nbsp;{{ displayText }} </span>
